/* Presentation only. Appstle owns plans; Shopify validates the cart selection. */
if (!customElements.get('collo-subscription-options')) {
  customElements.define('collo-subscription-options', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.closest('form');
      this.onVariant = (event) => {
        if (String(event.detail.product.id) === this.dataset.productId) {
          this.activate(event.detail.selectedVariant?.id);
        }
      };
      this.onChange = (event) => this.change(event);
      this.onQuantity = (event) => {
        if (event.target.matches('[name="quantity"]') || event.target.closest('.quantity--input__button')) this.updateBuyButtons();
      };
      this.form?.addEventListener('input', this.onQuantity);
      this.form?.addEventListener('click', this.onQuantity);
      this.addEventListener('change', this.onChange);
      document.addEventListener('booster:variant:select', this.onVariant);
      document.addEventListener('booster:variant:deselect', this.onVariant);
      this.querySelectorAll('[data-subscription-variant]').forEach((panel) => {
        const select = panel.querySelector('[data-selling-plan]');
        if (!select) return;
        const purchase = panel.querySelector('[value="subscription"]');
        purchase.checked = select.value !== '';
        const once = panel.querySelector('[value="once"]');
        if (once) once.checked = !purchase.checked;
        const oneTimeOption = select.querySelector('option[value=""]');
        if (oneTimeOption) {
          oneTimeOption.hidden = true;
          oneTimeOption.disabled = true;
        }
        panel.querySelector('[data-native-plan-label]').hidden = true;
        panel.querySelector('[data-purchase-options]').hidden = false;
        this.sync(panel);
      });
      this.activate(this.form?.querySelector('[name="id"]')?.value);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('input', this.onQuantity);
      this.form?.removeEventListener('click', this.onQuantity);
      document.removeEventListener('booster:variant:select', this.onVariant);
      document.removeEventListener('booster:variant:deselect', this.onVariant);
      this.initialized = false;
    }

    activate(variantId) {
      let hasPlans = false;
      this.querySelectorAll('[data-subscription-variant]').forEach((panel) => {
        const active = panel.dataset.subscriptionVariant === String(variantId);
        panel.hidden = !active;
        panel.disabled = !active;
        if (active) hasPlans = !!panel.querySelector('[data-selling-plan]');
      });
      this.hidden = !hasPlans && !this.querySelector('[data-complementary-packs]');
      this.updateBuyButtons();
    }

    change(event) {
      const panel = event.target.closest('[data-subscription-variant]');
      if (!panel || !event.target.matches('input[type="radio"], [data-selling-plan]')) return;
      if (event.target.matches('[data-plan-choice]')) panel.querySelector('[data-selling-plan]').value = event.target.value;
      this.sync(panel);
    }

    sync(panel) {
      const select = panel.querySelector('[data-selling-plan]');
      const subscribed = panel.querySelector('[value="subscription"]').checked;
      const intervals = panel.querySelector('[data-plan-options]');
      panel.querySelector('[data-subscription-note]').hidden = !subscribed;
      intervals.hidden = !subscribed;
      intervals.disabled = !subscribed;
      select.disabled = !subscribed;
      if (!subscribed) {
        select.value = '';
        this.updateBuyButtons();
        return;
      }
      if (!select.value) {
        // A merchant can mark the preferred interval in the Appstle plan name.
        const options = [...select.options].filter((option) => option.value);
        const chosen = options.find((option) => option.value === select.dataset.selectedPlan) || options.find((option) =>
          option.textContent.toLocaleLowerCase('de').includes('empfohlen')
        ) || options[0];
        select.value = chosen?.value || '';
      }
      select.dataset.selectedPlan = select.value;
      intervals.querySelectorAll('[data-plan-choice]').forEach((input) => { input.checked = input.value === select.value; });
      this.updateBuyButtons();
    }

    updateBuyButtons() {
      // Booster updates availability synchronously after dispatching its variant event.
      queueMicrotask(() => {
        if (!this.isConnected || !this.form) return;
        const panel = this.querySelector('[data-subscription-variant]:not([hidden])');
        const select = panel?.querySelector('[data-selling-plan]');
        const subscribed = !this.hidden && select && !select.disabled && select.value !== '';
        const packs = this.querySelector('[data-complementary-packs]');
        if (packs) packs.hidden = !!subscribed;
        const selector = `[data-buy-button="${this.dataset.productId}"]`;
        const buttons = [...this.form.querySelectorAll(selector), ...document.querySelectorAll(`.sticky--mobile ${selector}`)];
        for (const button of buttons) {
          const text = button.querySelector('[data-button-text]');
          if (!text) continue;
          if (!button.dataset.colloOnceText) button.dataset.colloOnceText = button.dataset.originalText || text.textContent;
          let price = subscribed ? select.selectedOptions[0]?.dataset.price : panel?.dataset.oncePrice;
          const cents = Number(subscribed ? select.selectedOptions[0]?.dataset.priceCents : panel?.dataset.onceCents);
          const quantity = Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value) || 1);
          if (quantity > 1 && Number.isFinite(cents) && this.dataset.currency) {
            price = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.dataset.currency }).format(cents * quantity / 100);
          }
          const label = subscribed ? 'Abo in den Warenkorb' : button.dataset.colloOnceText;
          button.dataset.originalText = this.querySelector('[data-complementary-packs]') && price ? `${label} · ${price}` : label;
          // Preserve sold-out, incomplete variant selection and in-flight request labels.
          if (!button.disabled) text.textContent = button.dataset.originalText;
        }
      });
    }
  });
}
